/**
 *
 * consent helper
 *
 */
import {
  COMBINED_CONSENT_PURPOSE_CODE,
  LAWHUB_ACCOUNT_CREATION_PURPOSE_CODE,
} from 'domains/session/constants';
import { config } from '../config';

/**
 * OLS migration phase 1 replaces the LawHub account creation consent with
 * the combined LawHub and JD account creation consent. AthenaNext uses the
 * same flag to pick the consent that it asks for.
 *
 * @returns {boolean} - True if the combined consent is the required consent
 */
export function isCombinedConsentEnabled() {
  return config.REACT_APP_IS_OLS_MIGRATION_PHASE_1_ENABLED === 'true';
}

/**
 * Get the purpose code of the account creation consent that the user must give
 *
 * @returns {string} - The required purpose code
 */
export function getAccountConsentPurposeCode() {
  return isCombinedConsentEnabled()
    ? COMBINED_CONSENT_PURPOSE_CODE
    : LAWHUB_ACCOUNT_CREATION_PURPOSE_CODE;
}

/**
 * Get the consent API URL template for the required account creation consent
 *
 * @returns {string} - The URL template, with %s for the candidate sequence
 */
export function getAccountConsentStatusUrl() {
  return isCombinedConsentEnabled()
    ? config.REACT_APP_GET_LH_JD_ACCOUNT_CONSENT_STATUS_URL
    : config.REACT_APP_GET_LH_ACCOUNT_CONSENT_STATUS_URL;
}
